import { c as _c } from "react/compiler-runtime";
import React, { useMemo } from 'react';
import { useEventCallback } from '../../hooks/useEventCallback';
import { prepareProps } from '../../utils/propUtils';
import { PropsWithoutChildren } from '../../utils/utilityTypes';
import { SortableListDropTarget, SortableListDropTargetProps } from '../SortableListDropTarget/SortableListDropTarget';
import { RenderSortableListItem, SortableListItem } from '../SortableListItem/SortableListItem';
export type SortableListProps<T> = PropsWithoutChildren<{
  items: Array<T>;
  renderItem: RenderSortableListItem<T>;
  getItemKey: (item: T) => string;
  onItemSorted: (sortInfo: {
    item: T;
    previousItem: T | null;
    nextItem: T | null;
  }) => void;
}>;
export const SortableList = React.memo(props => {
  const $ = _c(1);
  const {
    items,
    renderItem,
    getItemKey,
    onItemSorted
  } = prepareProps({
    props,
    ignoreChildren: true
  });
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = Symbol("SortableList");
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const dndType = t0;
  const handleDrop = useEventCallback(dropInfo => {
    if (dropInfo.item === dropInfo.previousItem || dropInfo.item === dropInfo.nextItem) {
      return;
    }
    onItemSorted({
      item: dropInfo.item,
      nextItem: dropInfo.nextItem,
      previousItem: dropInfo.previousItem
    });
  });
  return <><SortableListDropTarget dndType={dndType} previousItem={null} nextItem={items[0] ?? null} onDrop={handleDrop} data-testid="SortableList.DropTarget" />{items.map((item, index) => <React.Fragment key={getItemKey(item)}><SortableListItem item={item} renderItem={renderItem} dndType={dndType} /><SortableListDropTarget dndType={dndType} previousItem={item} nextItem={items[index + 1] ?? null} onDrop={handleDrop} data-testid="SortableList.DropTarget" /></React.Fragment>)}</>;
}) as <T>(props: SortableListProps<T>) => React.JSX.Element;